/**
 * A request to an account endpoint of UserAccountController (sign-in, sign-up,
 * password reset) from a page script: the sign-in window of the map
 * (newmobilemap/modules/auth-modal.js) and the sign-in form of the start
 * dialog (newmobilemap/modules/start-dialog-listings.js). A same-origin POST
 * of the form fields with the page's CSRF token (window.RCN_CSRF) as a field
 * and as X-CSRF-Token; X-Requested-With makes the endpoint answer JSON.
 *
 * Resolves with { ok, status, payload }: the endpoint's JSON ({ success, user,
 * errors, message }, 422 when refused), or payload null when the answer is not
 * JSON (Yii's HTML page of an expired token, 400). Rejects when no answer
 * arrives, so the caller can tell a network error apart.
 *
 * @param {string} url the endpoint, from window.RCN_AUTH_URLS
 * @param {FormData|URLSearchParams} params the fields of the form; the CSRF field is added when missing
 * @returns {Promise<{ok: boolean, status: number, payload: object|null}>}
 */
export function postAuthForm(url, params) {
    const csrf = window.RCN_CSRF || {};
    if (csrf.param && csrf.token && !params.has(csrf.param)) params.append(csrf.param, csrf.token);
    const headers = { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' };
    if (csrf.token) headers['X-CSRF-Token'] = csrf.token;
    return window.fetch(url, { method: 'POST', credentials: 'same-origin', headers, body: params })
        .then((response) => response.json()
            .catch(() => null)
            .then((payload) => ({ ok: response.ok, status: response.status, payload })));
}
